var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"preloader"},[_c('img',{staticClass:"imgr mt-3 mb-3",attrs:{"src":"/img/logo2.png","size":"custom-size","height":50}})])
}
var staticRenderFns = []

export { render, staticRenderFns }